import axios from 'axios'
import base64 from 'base-64'
import config from './../config.json'

const getRandomKey = () => Math.random() * 1000000

// Create a single instance of Axios
const instance = axios.create({
  baseURL: config.apiUrl,
  headers: {
    api_key: base64.encode(`${getRandomKey()}|sheepoll|${getRandomKey()}`),
  },
})

const http = {
  /**
   * GET Method
   * @param {Object} req { url, params }
   * @param {fn} successCallback
   * @param {fn} failureCallback
   */
  get(req, successCallback = null, failureCallback = null) {
    const { url, params } = req

    instance
      .get(url, {
        params: {
          ...params,
        },
      })
      .then((response) => successCallback && successCallback(response))
      .catch((error) => failureCallback && failureCallback(error))
  },
}

export {
  http
}



// WEBPACK FOOTER //
// ./src/lib/http.js